<template>
  <div id="newPost">
    <NewPostMobile  :post="post"
                    :back="back" :publish="publish" :setImageData="setImageData"
                    v-show="!$store.state.isDesktop"
                    ref="newPostMobile"
    ></NewPostMobile>
    
    <NewPostDesktop :post="post" :DateTime="DateTime"
                    :back="back" :publish="publish" :setImageData="setImageData"
                    v-show="$store.state.isDesktop"
                    ref="newPostDesktop"
    ></NewPostDesktop>
  </div>
</template>

<script>

  import Billboard from '../../core/Billboard';
  import FileUploader from "../components/FileUploader";
  import NewPostMobile from '@/components/mobile/NewPost';
  import NewPostDesktop from '@/components/desktop/NewPost';
  import { DateTime } from "luxon";

  export default {

    name: "newPost",

    components: {
      FileUploader,
      NewPostMobile,
      NewPostDesktop
    },

    data() {
      return {
        post: {
          title: "",
          subTitle: "",
          body: "",
          start: null,
          end: null,
          imageData: null
        },
        DateTime
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "billboard.new",
        headerIcon: "/svg/news.svg"
      });
    },
    
    methods: {
      back() {
        this.$router.push("/billboard");
      },
      checkFormValidity() {
        return (this.$store.state.isDesktop ?
          !this.$refs.newPostDesktop.$validate.valid()
          : !this.$refs.newPostMobile.$validate.valid())
      },
      async publish() {
        if (this.checkFormValidity()) {
          showAffirmation(this.$t("form.oops"), this.$t("form.info_missing_text"));
          return;
        }
        showSpinner();
        let result;
        try {
          result = await Billboard.createPost(this.post.title, this.post.subTitle, this.post.body, this.post.start, this.post.end, this.post.imageData);
        } catch (e) {
          showAffirmation(this.$t("form.oops"), this.$t("form.could_not_send"));
          hideSpinner();
          return;
        }
        hideSpinner();
        if (result.status == 200) {
          this.$router.push("/billboard");
        } else {
          showAffirmation("Erreur", "Nous n'avons pas pu ajouter votre billet au babillard.");
        }
      },
      setImageData(data) {
        this.post.imageData = data;
      }
    }

  }

</script>

<style lang="scss" scoped>

  #newPost {
    background-color: #f2f3f4;
  }

</style>
